import dayjs from 'dayjs'

import { Button, DialogClose, DialogContent, DialogHeader } from '@/_components/ui'
import { formatCurrency } from '@/_helpers/currency'
import { formatPercentage } from '@/_helpers/percentage'
import type {
  TBulkSimulateApplicationInputDTO,
  TSimulateApplicationOutputDTO,
} from '@doutorsim/shared/applications'
import { Text } from '../../_components/ui/typography'

interface InstallmentsDetailsProps {
  simulationData: TBulkSimulateApplicationInputDTO
  installment: TSimulateApplicationOutputDTO
  selectInstallment: (installment: TSimulateApplicationOutputDTO) => void
}

export const InstallmentsDetailsDialog = ({
  simulationData,
  installment,
  selectInstallment,
}: InstallmentsDetailsProps) => {
  const amountPerInstallment = installment.monthlyPaymentAmount

  return (
    <DialogContent className="w-[20.8125rem] py-5">
      <DialogHeader className="text-sm font-semibold">Detalhes da oferta</DialogHeader>
      <span className="text-2xl font-bold text-brand-green-primary-5">
        {installment.numPayments}x {formatCurrency(amountPerInstallment)}
        <Text className="text-xs font-semibold">
          Total de {formatCurrency(installment?.totalAmountOwed)}
        </Text>
      </span>

      <div className="flex flex-col gap-[14px]">
        <h3 className="text-sm font-bold">Informações do parcelamento</h3>

        <div className="space-y-[5px] text-brand-grayscale-7">
          <div className="flex w-full justify-between">
            <span>Valor solicitado</span>
            <span>{formatCurrency(simulationData.requestedAmount)}</span>
          </div>

          <div className="flex w-full justify-between">
            <span>Prazo</span>
            <span>{installment.numPayments} parcelas</span>
          </div>

          <div className="flex w-full justify-between">
            <span>Primeira Parcela</span>
            <span>{dayjs(simulationData.firstPaymentDate).format('DD/MM/YYYY')}</span>
          </div>

          <div className="flex w-full justify-between">
            <span>Taxa de juros mensal</span>
            <span>{formatPercentage(installment.monthlyInterestRate)}</span>
          </div>
        </div>
      </div>

      <div className="mt-5 flex justify-end gap-3">
        <DialogClose asChild>
          <Button variant="gray" size="xs" className="font-bold">
            Cancelar
          </Button>
        </DialogClose>
        <DialogClose asChild>
          <Button size="xs" onClick={() => selectInstallment(installment)}>
            Selecionar oferta
          </Button>
        </DialogClose>
      </div>
    </DialogContent>
  )
}
